/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_DeletedInputs */

const en_origin_deleted = /** @type {(inputs: Origin_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin deleted`)
};

const es_origin_deleted = /** @type {(inputs: Origin_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origen eliminado`)
};

/**
* | output |
* | --- |
* | "Origin deleted" |
*
* @param {Origin_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const origin_deleted = /** @type {((inputs?: Origin_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_origin_deleted(inputs)
	return es_origin_deleted(inputs)
});